/* eslint-disable no-constant-condition */
/* eslint-disable no-nested-ternary */
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AddIcon from '@mui/icons-material/Add';
import DataTable from '../../Components/DataTable/DataTable';
import Navbar from '../../Components/Navbar/Navbar';
import Sidebar from '../../Components/Sidebar/Sidebar';
import TableList from '../../Components/TableList/TableList';
import './userlists.css';

function Lists({ type }) {
    const { t } = useTranslation();
    return (
        <div className="list_page">
            <Sidebar />

            <div className="list_page_main">
                <Navbar />

                {/* mui data table */}
                <div className="data_table">
                    <div className="btnn">
                        <Link
                            to={`/${
                                type === 'product' ? 'products' : 'user' ? 'users' : 'blogs'
                            }/addnew`}
                            style={{ textDecoration: 'none' }}
                        >
                            <Button
                                startIcon={<AddIcon />}
                                className="addNewProductButton"
                                type="button"
                            >
                                {t('addNewProduct')}
                            </Button>
                        </Link>
                    </div>

                    {type === 'user' ? <DataTable /> : <TableList />}
                </div>
            </div>
        </div>
    );
}

export default Lists;
